import React, { FC } from 'react';

import { useSelector } from 'react-redux';

import { selectIsNoiseCancellationEnabled } from '../../../../../../settings';
import { AdditionalSoundSection } from './additional-sound-section';
import { InputDeviceSection } from './input-device-section';
import { OutputDeviceSection } from './output-device-section';
import css from './styles.css';

export const SoundWithDiagnostic: FC = () => {
    const isNoiseCancellationEnabled = useSelector(selectIsNoiseCancellationEnabled);
    return (
        <div className={css.mainWrapper}>
            <InputDeviceSection />
            <OutputDeviceSection />
            {isNoiseCancellationEnabled && <AdditionalSoundSection />}
        </div>
    );
};
